export default "__VITE_ASSET__DSWBbJhm__"